<template>

    <main id="main" class="ms-sm-auto">
        <div class="container">

            <div class="card">
                <div class="card-header">
                    <div class="card-title">{{$t("unlock_full_access")}}</div>
                </div>
                <div class="card-body">
                    <div class="payment-packages">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="payment-package-item active">
                                    <div class="title">PLUS ACCOUNT</div>
                                    <div class="desc">75.000vnd/<span class="sm-text">{{$t("month")}}</span></div>
                                    <div class="desc-box">
                                        <div class="desc-box-item">
                                            <i class="lisa-icon-payment-check-1"></i> <span>{{$t("plus_account_1")}}</span>
                                        </div>
                                        <div class="desc-box-item">
                                            <i class="lisa-icon-payment-check-1"></i> <span>{{$t("plus_account_2")}}</span>
                                        </div>
                                        <div class="desc-box-item">
                                            <i class="lisa-icon-payment-check-1"></i> <span>{{$t("plus_account_3")}}General English: much more content than STANDARD</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="payment-package-item">
                                    <div class="title">PRO ACCOUNT</div>
                                    <div class="desc">199.000đ/<span class="sm-text">{{$t("month")}}</span></div>
                                    <div class="desc-box">
                                        <div class="desc-box-item">
                                            <i class="lisa-icon-payment-check-2"></i> <span>{{$t("pro_account_1")}}</span>
                                        </div>
                                        <div class="desc-box-item">
                                            <i class="lisa-icon-payment-check-2"></i> <span>{{$t("pro_account_2")}}</span>
                                        </div>
                                        <div class="desc-box-item">
                                            <i class="lisa-icon-payment-check-2"></i> <span>{{$t("pro_account_3")}}</span>
                                        </div>
                                        <div class="desc-box-item">
                                            <i class="lisa-icon-payment-check-2"></i> <span>{{$t("pro_account_4")}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mt-20 text-center">
                                <button class="btn btn-main" style="padding: 8px 60px;">{{$t("upgrade_account")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </main>


</template>

<script>
    import axios from "axios";
    import {pushQueries, soundClick} from '../../utils/utils'
    import {mapGetters} from 'vuex'
    import {getInboxs, readInbox} from "../../models/inbox";
    import {getPackages, postPayment} from "../../models/payment";
    import {claimDailyBonus} from "../../models/reward";

    export default {
        name: "ParentUpgradeAccount",
        title: 'Parents - Upgrade Account',

        data() {
            return {
                packages: [],
                gates: [],
                isLoading: true,
                product: '',
                package_select: '',
                method: '',
                screen: 1
            };
        },

        created() {
            this.$store.commit('setMenuActive', 'parent');

            this.fetch();
        },

        // watch: {
        //     'package_select': function(newVal, oldVal) {
        //         if(newVal != ''){
        //             this.screen = 2
        //         }
        //     },
        // },

        methods: {
            async fetch(page = 1) {
                const that = this;
                //pushQueries(this.$router, '/inbox', params);

                await axios.all([
                    getPackages(),
                ]).then(axios.spread((package_response) => {
                    that.isLoading = false;
                    //that.$store.commit("setLoading", false);

                    if (package_response.data.code != 0) {
                        return;
                    }
                    that.packages = package_response.data.results.packages || [];
                    that.gates = package_response.data.results.gate || [];

                }));
            },

            Payment() {
                const that = this;

                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('product_id', this.product);
                formData.append('voucher', 'xxx');
                formData.append('method', this.method);
                postPayment(formData).then((data) => {
                    that.$store.commit("setLoading", false);
                    if (data.data.code == 0) {
                        window.location.href = data.data.results.url;
                    }
                    else {
                        alert(data.data.results);
                    }
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);
                    alert(response.data.results);
                });
            },

            getSoundClick() {
                soundClick();
            },

        }
    }
</script>

<style scoped>
    [type="radio"]:not(:checked), [type="radio"]:checked {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }

    .slect-method [type="radio"] + label:before,
    .slect-method [type="radio"] + label:after {
        display: none;
    }

    .slect-method [type=radio]:checked + label.payment-method-item {
        opacity: 1;
        border: 2px solid #40C0F6;
    }
    .package-content-1 img{
        filter: grayscale(1);
    }
    .select-upgrade-type [type=radio]:checked + label.package .package-content-1 img{
        filter: grayscale(0);
    }

    .slect-method label {
        display: block;
        /*width: 100%;*/
        /*height: 100%;*/
    }

    .slect-show {
        display: flex;
    }

    .slect-hide {
        display: none;
    }

    .slect-product [type=radio]:checked + label.slect-package {
        color: #ffffff;
        background: #e98437;
    }
    .payment-method-item{
        padding: 0;
    }
    .img-gate-box {
        height: calc(100% - 30px);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 25px 10px 25px;
    }
    .img-gate-box img{
        width: 100%;
    }

    .payment-method-text {
        font-size: 14px;
        line-height: 19px;
        color: #000000;
        margin-top: 0;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: start;
    }
</style>
